import { BASE_API_URL } from './constants';

export const apiUrl = (url: string) => `${BASE_API_URL}${url}`;
